<template>
  <AuthLayout>
    <div class="signin-head">
      <div class="signin-badge">로그인</div>
      <h1 class="signin-title">Sign in</h1>
    </div>

    <form class="signin-form" @submit.prevent="onLogin">
      <!-- 전화번호 -->
      <UiInput
        placeholder="전화번호 ( - 제외)"
        type="tel"
        inputmode="tel"
        autocomplete="tel"
        v-model="form.phone"
      />

      <!-- 비밀번호 -->
      <UiInput
        type="password"
        placeholder="비밀번호"
        v-model="form.password"
        autocomplete="current-password"
      />

      <UiButton
        type="submit"
        :disabled="!canSubmit || loading"
        :loading="loading"
      >
        로그인
      </UiButton>
    </form>

    <!-- 하단 링크 -->
    <div class="signin-links">
      <router-link to="/free-trial" class="signin-link">
        <span class="signin-link-text">무료체험 신청</span>
      </router-link>

      <router-link to="/forgot-password" class="signin-link">
        <span class="signin-link-text">비밀번호 재설정</span>
      </router-link>
    </div>
  </AuthLayout>
</template>

<script>
import { api } from "@/lib/api";
import UiButton from "@/components/UiButton.vue";
import UiInput from "@/components/UiInput.vue";
import AuthLayout from "@/components/AuthLayout.vue";

export default {
  name: "SignInView",
  components: { UiButton, UiInput, AuthLayout },
  data() {
    return {
      loading: false,
      form: { phone: "", password: "" },
    };
  },
  computed: {
    phoneValid() {
      const digits = (this.form.phone || "").replace(/\D/g, "");
      return digits.length >= 10 && digits.length <= 11;
    },
    canSubmit() {
      return this.form.phone && this.form.password && this.phoneValid;
    },
  },
  methods: {
    async onLogin() {
      if (!this.canSubmit || this.loading) return;
      this.loading = true;

      try {
        const res = await api("/v1/auth/sessions", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            phone_number: this.form.phone.replace(/\D/g, ""),
            password: this.form.password,
          }),
        });

        if (res.ok) {
          await res.json();
          this.$router.push("/dashboard");
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
/* 제목 */
.signin-head {
  margin-bottom: 24px;
  text-align: left;
}

.signin-badge {
  color: #78ff47;
  font-size: 18px;
  line-height: 150%;
  letter-spacing: -0.01em;
}

.signin-title {
  margin: 6px 0 0;
  font-weight: 700;
  font-size: 40px;
  line-height: 100%;
  letter-spacing: -2px;
  text-align: left;
}

/* 폼 */
.signin-form {
  display: grid;
  gap: 16px;
  width: 100%;
}

/* UiInput */
.signin-form :deep(.ui-input) {
  height: 54px;
  border-radius: 5px;
  border: 1px solid #fff !important;
  background: #151718;
  color: #fff;
  padding: 0 14px;
}

.signin-form :deep(.ui-input::placeholder) {
  color: rgba(255, 255, 255, 0.6);
}

.signin-form :deep(.ui-input:focus) {
  outline: none;
  border-color: #fff !important;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.25);
}

.signin-form .ui-btn {
  width: 100%;
}

/* 하단 링크 */
.signin-links {
  display: flex;
  justify-content: space-between;
  margin-top: 24px;
  gap: 16px;
  flex-wrap: wrap;
}

.signin-link {
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s ease;
}

.signin-link:hover {
  color: #78ff47;
}

.signin-link-text {
  display: block;
  padding: 8px 0;
}

@media (max-width: 640px) {
  .signin-title {
    font-size: 32px;
  }
}
</style>
